import { IntlProvider } from '@visma/react-intl-bundled-messages';
import { ReactKeycloakProvider } from '@visma/react-keycloak';
import { clientPromise } from 'api';
import React, { Suspense } from 'react';
import keycloak from './keycloak.js';
import './setBackendBaseURL.js';
export default function AppProvider({ children = null, fallback = null }) {
    return (React.createElement(Suspense, { fallback: fallback },
        React.createElement(ReactKeycloakProvider, { axios: clientPromise, authClient: keycloak, LoadingComponent: fallback !== null && fallback !== void 0 ? fallback : undefined },
            React.createElement(Suspense, { fallback: fallback },
                React.createElement(IntlProvider, null, children)))));
}
//# sourceMappingURL=AppProvider.js.map